import { platformSwitch } from '@certilogo/design-system/dist/configuration';

import * as web from './web';
import * as native from './native';

export const { Wrapper, Style, Skip } = platformSwitch({ web, native }) || {};
